import React from 'react';
import { addDays, format } from 'date-fns';
import { useController } from 'react-hook-form';
import { DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT } from '@cp/ds/src/components/form/components/field/dateTimePicker/const';
import { AvailableOnlyFieldProps, FormAvailableOnlyFieldName } from './model';

type UseAvailableOnlyFieldProps = Pick<AvailableOnlyFieldProps, 'form'>;

export const useAvailableOnlyField = ({ form }: UseAvailableOnlyFieldProps) => {
  const { field } = useController({ name: FormAvailableOnlyFieldName.AvailableOnly, control: form.control as never });

  const handleChange = React.useCallback(
    (newValue: boolean) => {
      if (newValue) {
        form.setValue(FormAvailableOnlyFieldName.Date, format(addDays(new Date(), 1), DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT));
        form.setValue(FormAvailableOnlyFieldName.Start, null);
        form.setValue(FormAvailableOnlyFieldName.End, null);
      } else {
        form.setValue(FormAvailableOnlyFieldName.Date, null);
        form.setValue(FormAvailableOnlyFieldName.Start, null);
        form.setValue(FormAvailableOnlyFieldName.End, null);
      }

      field.onChange(newValue);
    },
    [field, form],
  );

  return {
    onChange: handleChange,
    value: field.value,
  };
};
